











import Component, { mixins } from "vue-class-component";
import UploadingProgressMixin from "../mixins/UploadingProgressMixin";

@Component({ name: "LoadingListItem" })
export default class LoadingListItem extends mixins(UploadingProgressMixin) {}
